<template>
  <div :class="getBlockPadding(additionalSpacing)">
    <Background :background>
      <div
        class="flex w-full flex-col gap-24 md:max-w-[1120px]"
        :class="getPaddingClass({ background })"
      >
        <div class="flex flex-col gap-8">
          <h2
            v-if="title"
            :id="textToTarget(title, 'heading-2')"
            class="punchline text-center md:line-clamp-2"
          >
            {{ title }}
          </h2>

          <div class="heading-3 text-center">
            {{ description }}
          </div>
        </div>

        <CmsButton
          v-if="button"
          class="z-[2] m-auto"
          data-test="section-banner-cta-button"
          v-bind="button"
          full-width="adaptive"
          :tracking="trackingData"
        />

        <RelatedLinks
          v-if="relatedLinks"
          :align="relatedLinks.align"
          :display="relatedLinks.display"
          :links="relatedLinks.links"
          :size="relatedLinks.size"
          :tracking="trackingData"
        />
      </div>
    </Background>
  </div>
</template>

<script setup lang="ts">
import type { ContentBlockProps } from '@backmarket/nuxt-layer-cms/models/content-block'

import Background from '../../shared-components/Background/Background.vue'
import { textToTarget } from '../../utils/textToTarget'
import CmsButton from '../Button/Button.vue'
import RelatedLinks from '../RelatedLinks/RelatedLinks.vue'

import type { SectionBannerProps } from './SectionBanner.types'
import { getBlockPadding, getPaddingClass } from './SectionBanner.utils'

const props = withDefaults(
  defineProps<SectionBannerProps & ContentBlockProps>(),
  {
    additionalSpacing: 'None',
  },
)

const trackingData = {
  ...props.tracking,
  ...(props.title && { blockTitle: props.title }),
}

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])
</script>
